/**
 * touni-flocage-sync.js v2 — Optimisé vitesse
 */
(function () {
  'use strict';

  var FLOCAGE_VARIANT_ID = 48343237066971;
  var enCoursSynchro = false;
  var syncTimer = null;

  function propStr(item, key) {
    return (!item.properties || !item.properties[key]) ? '' : String(item.properties[key]).trim();
  }

  /* ── Retirer props flocage du maillot EN UNE SEULE opération ── */
  function nettoyerPropsMaillot(item, onDone) {
    var newProps = {};
    if (item.properties) {
      Object.keys(item.properties).forEach(function (k) {
        if (k !== 'Flocage' && k !== 'Nom' && k !== 'Numero') {
          newProps[k] = item.properties[k];
        }
      });
    }

    /* Trouver l'index de ligne */
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var lineIndex = 0;
        var items = cart.items || [];
        for (var i = 0; i < items.length; i++) {
          if (items[i].key === item.key) { lineIndex = i + 1; break; }
        }
        if (!lineIndex) { onDone(); return; }

        /* Supprimer + ré-ajouter en parallèle séquentiel rapide */
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: lineIndex, quantity: 0 })
        });
      })
      .then(function () {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: item.variant_id,
            quantity: item.quantity,
            properties: newProps
          })
        });
      })
      .then(function () { onDone(); })
      .catch(function () { onDone(); });
  }

  /* ── Sync principale — lit le panier UNE SEULE fois ─────────── */
  function syncPanier() {
    if (enCoursSynchro) return;
    enCoursSynchro = true;

    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = cart.items || [];
        var flocageItems = [];
        var maillotItems = [];

        for (var i = 0; i < items.length; i++) {
          var it = items[i];
          if (it.variant_id === FLOCAGE_VARIANT_ID) {
            flocageItems.push(it);
          } else if (propStr(it, 'Flocage') === 'Oui') {
            maillotItems.push(it);
          }
        }

        /* Rien à faire */
        if (flocageItems.length === 0 && maillotItems.length === 0) {
          enCoursSynchro = false;
          return;
        }

        var finish = function () {
          enCoursSynchro = false;
          /* Notifier le thème */
          try { document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true })); } catch(e) {}
          try { document.dispatchEvent(new CustomEvent('cart:refresh',  { bubbles: true })); } catch(e) {}
          /* Recharger page panier */
          if (window.location.pathname === '/cart') {
            setTimeout(function () { window.location.reload(); }, 200);
          }
        };

        /* Cas 1 : flocage supprimé → nettoyer props des maillots */
        if (flocageItems.length === 0 && maillotItems.length > 0) {
          var pending = maillotItems.length;
          var done = function () { if (--pending <= 0) finish(); };
          maillotItems.forEach(function (m) { nettoyerPropsMaillot(m, done); });
          return;
        }

        /* Cas 2 : maillot supprimé → supprimer flocages orphelins */
        var toDelete = {};

        if (maillotItems.length === 0) {
          /* Plus aucun maillot → supprimer tous les flocages */
          flocageItems.forEach(function (f) { toDelete[f.key] = 0; });
        } else {
          /* Chercher flocages sans maillot correspondant */
          flocageItems.forEach(function (f) {
            var fNom = propStr(f, 'Nom'), fNum = propStr(f, 'Numero');
            var found = maillotItems.some(function (m) {
              return propStr(m, 'Nom') === fNom && propStr(m, 'Numero') === fNum;
            });
            if (!found) toDelete[f.key] = 0;
          });
        }

        if (Object.keys(toDelete).length > 0) {
          fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates: toDelete })
          }).then(finish).catch(finish);
        } else {
          enCoursSynchro = false;
        }
      })
      .catch(function () { enCoursSynchro = false; });
  }

  /* ── Debounce — évite les appels multiples rapides ───────────── */
  function debouncedSync(delay) {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(syncPanier, delay || 300);
  }

  /* ── Intercepter fetch cart/change et cart/update ────────────── */
  var _orig = window.fetch.bind(window);
  window.fetch = function () {
    var args = Array.prototype.slice.call(arguments);
    var url  = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) ? args[0].url : '';
    var p    = _orig.apply(window, args);
    if (/\/cart\/(change|update)\.js(\?|$)/.test(url)) {
      p.then(function () { debouncedSync(400); }).catch(function () {});
    }
    return p;
  };

  /* ── Écouter les events panier ───────────────────────────────── */
  ['cart:updated', 'cart:refresh'].forEach(function (evt) {
    document.addEventListener(evt, function () { debouncedSync(500); });
  });

  /* ── Init ────────────────────────────────────────────────────── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { debouncedSync(400); });
  } else {
    debouncedSync(400);
  }

}());